// tslint:disable
export enum ClaimJobType {
    /**
     * @description IMS Medical Claim Feed
     */
    ImsClaimFeed = 1,
    /**
     * @description IMS Reconciliation (Payment Batch) Feed
     */
    ImsReconciliationFeed = 2,
}
(ClaimJobType as any)['IMSCLAIMFEED'] = 1;
(ClaimJobType as any)['IMSRECONCILIATIONFEED'] = 2;
